import React, {useState} from 'react';
import { v4 as uuidv4 } from "uuid"
import Cookies from "universal-cookie"
import ImageTransform from "@components/common/ggfx-client/module/components/image-transform";
import SearchList from './SearchList';
import { Link } from "gatsby"
import FloorPlanModal from "../SearchResult/floorPlanModal"
import VideoPlay from "../Play/property-results-video"
import PropertyBox from '../property-box/property-box';
import { Col, Container, Row } from "react-bootstrap";
// import parse from "html-react-parser"
import { currencyFormat } from '@components/common/utils';
import ContentBlock from "../content/Content";
import Card from "../card/card"
import classNames from "classnames"
import LinkIcon from "../link-icon/link-icon"
import { ShowProcessedImage } from '../common/ggfx-client/module/components/show-image';
import noImg from "../../../src/images/no-image.png"
import imageConfig from "../../../static/images/config.json"
import PropertyCalloutBanner from '../callout-banner/property-callout-banner';
import PriceComp from "@components/Property/Price"
import Modal from 'react-bootstrap/Modal';
import BookAViewingForm from "../../Forms/BookAViewing"
import CardLet from '../news-lettings/card-let';
import PropertyEnquireForm from '../../Forms/PropertyEnquire';
import Noimg from "../../components/no-img/Noimg"
let text_truncate = function(str, length, ending) {
    length = 250;
    //

    if (ending == null) {
      ending = '...';
    }
    
    if (str?.length > length) {
      return str?.substring(0, length - ending.length) + ending;
    } else {
      return str;
    }
  };

const mycookies = new Cookies()
const InfiniteHits = ({
  hits,
  // hasPrevious,
  // refinePrevious,
  // hasMore,
  // refineNext,
  // location,
  tag,
  source,
  map,
  type,
  department,
  nostats
  // userObjects,
}) => {
  const [showForm, setShowForm] = useState(false);
  const [index, setIndex] = useState(null);
  const openform = (i) => {
          if(index === i){
            setShowForm(!showForm)
          setIndex(null)
          }
          else {
            setShowForm(!showForm)
          setIndex(i)
          }
  }
  return (
  <>
    {hits?.map((hitItem, i) => {
      // property details url structure

      let uriStr = ""
      let mysale = ""
      let hit = { ...hitItem }
      // mapping
      hit.searchType = hit.searchType || hit.search_type;

      if (hit.searchType === "sales" && hit.department === "residential") {
        uriStr = `property-for-sale/`
        mysale = `myResSaleProp`
      } else if (
        hit.searchType === "lettings" &&
        hit.department === "residential"
      ) {
        uriStr = `property-to-rent/`
        mysale = `myResRentProp`
      }

      if (tag === "sold") {
        uriStr = `property-sold/`
        mysale = `myResSaleProp`
      } else if (tag === "let") {
        uriStr = `property-let/`
        mysale = `myResRentProp`
      }

      let url_one = ""
      let photoplans = false

      if (hit.virtual_tour) {
        url_one = String(hit.virtual_tour)
        photoplans = url_one.indexOf("photoplans.planup") > -1
      }
      let processedImages = JSON.stringify({});
      if (hit.imagetransforms?.images_Transforms) {
        processedImages = hit.imagetransforms?.images_Transforms;
      }
      // property details url structure
      if (department === 'newhomes') {
        hit.price_qualifier = 'Price from';
        uriStr = 'new-homes/current-developments-details/';
        hit.bedroom = hit.title;

        //remove html tags from a string, leaving only the inner text
        function removeHTML(str) {
          var tmp = document.createElement("DIV");
          tmp.innerHTML = str;
          return tmp.textContent || tmp.innerText || "";
        }

        hit.description = removeHTML(hit.description)
      }
      return (
        <>
        {nostats && i== 0 ? 
<div className='div-search'>
<h5>
              Unfortunately, we do not currently have any properties that match
              your search criteria.</h5>
              <br/>
              <p>We have selected some of our showcase properties for you to browse below. Alternatively, you can search again in the bar above.</p>
            <br/>
            <br/>
            <br/>
            </div> 
            : null}
        <div
          className={hits?.length === 1 ? "property-card mysingleproperty no-flex" : "property-card mysingleproperty"}
          id={`item${nostats ? hit?.id : hit.objectID}`}
          data-objectid={`item${nostats ? hit?.id : hit.objectID}`}
          data-lat={hit?._geoloc?.lat}
          data-lng={hit?._geoloc?.lng}
        >
          {/* {map ? "true" : "false"} */}
          {map ?
            <Card>
              <Link onClick={() => {sessionStorage.setItem('searchindex', nostats ? hit?.id : hit.objectID)}} to={`/${uriStr}${hit.slug}-${nostats ? hit?.id : hit.objectID}/`}>
                <div className={hit?.status === "Sold Subject To Contract" || hit?.status === "Let Agreed" ? "property-box__badge yellow" : "property-box__badge"}>{hit?.status}</div>
                {/* <Card.Head onImageHoverZoom 
            image={images[x.image]} 
            alt={x.alt || "property"} 
            /> */}
                {/* {JSON.stringify(hit?.images1)}
                {JSON.stringify(imageConfig.property.searchResults1.sizes)} */}
                {/* {JSON.stringify(hit?.images)} */}
                {nostats ? 
                <ImageTransform
                imagesources={hit?.images && hit?.images[0]?.url}
                // renderer="srcSet"
                imagename={"property.images.searchResults1"}
                attr={{ alt: `${hit?.display_address?hit?.display_address:""} - Strakers Estate Agents`, className: "" }}
                imagetransformresult={processedImages}
                id={hit.id}
              />
: hit?.images1?.length > 0 ?
                <ShowProcessedImage
                  images={hit?.images1 && hit?.images1[0]}
                  attr={{ className: '', alt: `${hit?.display_address?hit?.display_address:""} - Strakers Estate Agents` }}
                  transforms={imageConfig.property.searchResults2.sizes} />

                  : 
                  // <img src={noImg} className="no-image-style" />
                  <Noimg class="no-image-style" imagename="coming-soon-image.Image.searchResults2" />
                }
              </Link>
              <Card.Body>
                <Link  className="address-min-height" onClick={() => {sessionStorage.setItem('searchindex', nostats ? hit?.id : hit?.objectID)}} to={`/${uriStr}${hit.slug}-${nostats ? hit?.id : hit.objectID}/`}>
                  <h5>{hit.display_address}</h5>
                  <h5>{hit.area}</h5>
                </Link>

                <div className="card__description d-flex">
                <PriceComp {...hit} />
                  {/* <span className="card__subtitle fz14 d-inline-block">
                    {hit?.price_qualifier !== "0" ? hit?.price_qualifier : ""}
                  </span>
                  <span className="fw-bolder card__price fz14">{currencyFormat(hit?.price, '£', false)}</span> */}
                </div>
                <p>{hit?.title?.replace("land", "Land")?.replace(/-/g, ' ')}</p>
              </Card.Body>
              <Card.Footer>
                <Row className="g-0 flex-nowrap justify-content-between">
                  <Col>
                    <Link class="link-icon blue-link-hover d-flex align-items-center"
                     onClick={() => {sessionStorage.setItem('searchindex', nostats ? hit?.id : hit?.objectID)}}
                      to={`/${uriStr}${hit?.slug}-${nostats ? hit.id : hit?.objectID}/`}
                    >
                      <div
                        className={`link-icon__text fw-bolder fz14 position-relative order-0`}
                      >
                        Details
                      </div>
                      <i className={classNames(`icon icon--eye`)}></i>
                    </Link>
                    {/* <LinkIcon text="Details" icon="eye" /> */}
                  </Col>

                  <Col>
                    <Card.Delimiter />
                  </Col>

                  <Col>
                    <a className="link-icon blue-link-hover d-flex align-items-center"
                    // to={`/${uriStr}${hit.slug}-${hit.objectID}`}
                    href="javascript:void(0)"
                    onClick={(e) => openform(i)}
                    >
                      <div
                        className={`link-icon__text fw-bolder fz14 position-relative order-0`}
                      >
                        Enquire
                      </div>
                      <i className={classNames(`icon icon--arrow-up-right`)}></i>
                    </a>
                    {/* <LinkIcon text="Enquire" /> */}
                  </Col>
                </Row>
              </Card.Footer>
            </Card>
            :

            <>
            {i % 4 === 0 && i !== 0 &&
            <PropertyCalloutBanner addShell={false} />
            }
            <PropertyBox
              map={map}
              key={i}
              badge={hit?.status}
              className="mysingleproperty"
              nostats={nostats}
              id={`${nostats ? hit?.id : hit?.objectID}`}
              bed={hit?.bedroom} bathroom={hit?.bathroom} room={hit?.reception}
              images={nostats ? hit?.images[0] : hit?.images1}
              images1={nostats ? hit?.images?.slice(1, 4) : hit?.images2}
              imagetransforms={hit?.imagetransforms}
              // id={hit?.id}
              url={`/${uriStr}${hit.slug}-${nostats ? hit?.id : hit?.objectID}/`}
              onClick={(e) => openform(i)}
              display_address={hit?.display_address}
            >
              <Row className="justify-content-between">
                <Col>
                {/* {JSON.stringify(hit?.images[0])} */}
                  <h4>
                    <Link
                     onClick={() => {sessionStorage.setItem('searchindex', nostats ? hit?.id : hit?.objectID)}}
                     to={`/${uriStr}${hit.slug}-${nostats ? hit?.id : hit.objectID}/`}>
                      {hit?.display_address ? hit?.display_address : ''}
                      <span className="d-block d-md-inline"> {hit?.area ? hit?.area : ""}</span>
                    </Link>
                  </h4>
                  <h5>
                  <PriceComp {...hit} />
                    {/* {hit?.price_qualifier !== "0" ? hit?.price_qualifier : ""} <strong>{currencyFormat(hit?.price, '£', false)}</strong> */}
                  </h5>
                  <h6>{hit?.title?.replace("land", "Land")?.replace(/-/g, ' ')}</h6>
                </Col>
              </Row>

              <p className="d-none d-md-block">
                {/* <ContentBlock Content={text_truncate(hit?.description)} /> */}
                {/* {text_truncate(hit?.description)} */}
                <div
          dangerouslySetInnerHTML={{ __html: text_truncate(hit?.description) }}
        />
              </p>
            </PropertyBox>
            </>
          }

          {/* {index} -- {i} -- {showForm ? "true" : 'false'} */}
          <Modal className="teamdetails popupForm" backdrop="static" size="lg" show={index === i && showForm} onHide={() => { setShowForm(false);setIndex(null) }}>
                                            <Modal.Header closeButton>
                                                <Modal.Title> <div className="form__head">
          <h4>Enquire about Property</h4>
        {/* {JSON.stringify(hit.images1)} */}
                                                 {/* {hit?.images1 && hit?.images1[0]['608x404']} */}
                                                  {/* {`${process.env.GATSBY_SITE_URL}${uriStr}${hit.slug}-${hit.objectID}`}
                                                   {hit?.display_address}
                                                    {hit?.search_type} */}
        </div>
</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body> 
                                                <PropertyEnquireForm
                                                id={hit?.objectID}
                                                 property_img={hit?.images1 && hit?.images1?.[0]?.['608x404']}
                                                  page_url={`${process.env.GATSBY_SITE_URL}${uriStr}${hit.slug}-${hit.objectID}`}
                                                   property_title={hit?.display_address}
                                                    type={hit?.search_type}
                                                data={hit}
                                                />  
                                            </Modal.Body>

                                        </Modal>
          {/* {tag == "sold" || tag == "let" ? (
            <div className="result-tile">
              <div className="map-wrapper">
                <SearchList
                  {...hit}
                  // images={hit.images}
                  // floorplan={hit.floorplan}
                  // virtual_tour={hit.virtual_tour}
                  Title={hit.display_address}
                  Address={hit.title}
                  // status={hit.status}
                  link=""
                  priceQualifier={hit.price_qualifier && hit.price_qualifier}
                  priceDetails={hit.price && hit.price.toLocaleString()}
                  // bedroom={hit.bedroom}
                  // bathroom={hit.bathroom}
                  // reception={hit.reception}
                  // description={hit.description}
                  unkey={uuidv4()}
                  // photoplans={photoplans}
                  source={source}
                  //   videoid={item.video}
                />
                {hit.floorplan && JSON.stringify(hit.floorplan) !== "[]" ? (
                  <FloorPlanModal floorplanimg={hit.floorplan.url} />
                ) : (
                  ""
                )}
                <>
                  {hit.status === "Sold STC" ? (
                    <div className="flag">SOLD STC</div>
                  ) : (
                    ""
                  )}
                  {hit.status === "Let Agreed" ? (
                    <div className="flag">LET AGREED</div>
                  ) : (
                    ""
                  )}
                  {photoplans == true ? (
                    <a
                      href={hit.virtual_tour}
                      target="_blank"
                      className="photoplan"
                    >
                      <span className="play-btn">
                        <i className="icon-play"></i>
                      </span>
                    </a>
                  ) : (
                    <>
                      {hit.virtual_tour ? (
                        hit.virtual_tour.length > 0 ? (
                          <VideoPlay url={hit.virtual_tour} />
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </>
              </div>
            </div>
          ) : (
            <div className="result-tile">
              <Link
                onClick={() =>
                  mycookies.set(mysale, hit.objectID, {
                    path: "/",
                    maxAge: 300,
                  })
                }
                // to={`/${uriStr}${hit.slug}-${hit.objectID}`}
                propID={hit.objectID}
                className="map-wrapper"
              >
                <SearchList
                  {...hit}
                  // images={hit.images}
                  // floorplan={hit.floorplan}
                  // virtual_tour={hit.virtual_tour}
                  Title={hit.display_address}
                  Address={hit.title}
                  // status={hit.status}
                  link={`/${uriStr}${hit.slug}-${hit.objectID || hit.id}`}
                  priceQualifier={hit.price_qualifier && hit.price_qualifier}
                  priceDetails={hit.price && hit.price.toLocaleString()}
                  // bedroom={hit.bedroom}
                  // bathroom={hit.bathroom}
                  // reception={hit.reception}
                  // description={hit.description}
                  unkey={uuidv4()}
                  // photoplans={photoplans}
                  source={source}
                  //   videoid={item.video}
                />
              </Link>
            </div>
          )} */}
        </div>
      </>
      )
    })}
  </>
)
  }

export default InfiniteHits;
